import React from 'react'
import Devices from '../configuration/devices/Devices'
import SmartNavigator from '../generic/SmartNavigator'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import DeviceGroup from '../configuration/deviceGroups/DeviceGroup'

const MainDevices = (props) => {
  const { t_ } = useSmartTranslation()
  const activePath = props.activePath

  const componentsInfo = [
    {
      title: t_('Assets'),
      component: <Devices />,
      to: '/configuration/assets'
      // permissionCode: 'ASSET TAB'
    },
    {
      title: t_('Asset Groups'),
      component: <DeviceGroup />,
      to: '/configuration/assetGroups'
      // permissionCode: 'ASSET GROUPS'
    }
  ]
  return (
    <div>
      <SmartNavigator componentsInfo={componentsInfo} selected={activePath} />
    </div>
  )
}

export default MainDevices
